import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  "data-test-id": "server-uuid-short"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_socket = _resolveComponent("ui-socket")!

  return (_openBlock(), _createElementBlock("span", {
    title: _ctx.title,
    "data-test-id": "server-title"
  }, [
    _createElementVNode("span", {
      style: _normalizeStyle({ color: _ctx.color }),
      "data-test-id": "server-color"
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["glyphicon", [`glyphicon-${_ctx.glyphicon}`]])
      }, null, 2),
      (_ctx.showId)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.uuidShort), 1))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("span", {
      style: {"margin-left":"0.5em"},
      class: _normalizeClass(_ctx.css),
      "data-test-id": "server-name"
    }, _toDisplayString(_ctx.name), 3),
    _createVNode(_component_ui_socket, {
      section: "server-info-display",
      location: "badges",
      "socket-data": { uuid: _ctx.uuid }
    }, null, 8, ["socket-data"])
  ], 8, _hoisted_1))
}